<template>
  <v-navigation-drawer v-model="drawer" app class="grey lighten-3" width="230">
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-img src="@/assets/soae.png" height="32" class="mb-2" contain />
            <span class="pb-2 d-block text-center">Versão: {{ version }}</span>
            <v-divider />
          </v-list-item-title>
          <v-list-item-title>
            <v-img
              :src="dados.logo"
              contain
              max-height="70"
              class="mt-2"
            ></v-img>
            <span class="mt-2 d-block text-center nome">
              Usuário: {{ dados.nome }}
            </span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list-item v-for="(item, key) in items" :key="key" :to="item.to">
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon v-show="item.extra && dados.msg_nao_lidas > 0">
          <v-avatar color="primary" size="30">
            <span class="white--text caption">{{ dados.msg_nao_lidas }}</span>
          </v-avatar>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item @click="$auth.logout()">
        <v-list-item-action>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Sair</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { Usuario, Auth } from '../service'

export default {
  name: 'drawer',
  props: {
    value: Boolean
  },
  watch: {
    value(value) {
      this.drawer = value
    },
    drawer(value) {
      this.$emit('input', value)
    }
  },
  data() {
    return {
      drawer: this.value,
      items: [
        { title: 'Início', icon: 'mdi-home', to: '/', extra: false },
        {
          title: 'Atividades',
          icon: 'mdi-library',
          to: '/atividades',
          extra: false
        },
        {
          title: 'Comunicados',
          icon: 'mdi-bullhorn',
          to: '/comunicados',
          extra: false
        },
        {
          title: 'Eventos',
          icon: 'mdi-calendar',
          to: '/eventos',
          extra: false
        },
        {
          title: 'Mensagens',
          icon: 'mdi-forum',
          to: '/mensagens',
          extra: true
        },
        {
          title: 'Galerias',
          icon: 'mdi-camera',
          to: '/galerias',
          extra: false
        },
        {
          title: 'Refeições',
          icon: 'mdi-food',
          to: '/refeicoes',
          extra: false
        },
        {
          title: 'Autorizações',
          icon: 'mdi-account-edit',
          to: '/autorizacoes',
          extra: false
        }
      ],
      dados: {},
      version: process.env.VUE_APP_VERSION
    }
  },
  async created() {
    if (Auth.isAuthenticated) {
      this.dados = await Usuario.getPerfil({
        escola: localStorage.getItem('escola')
      })
    }
  }
}
</script>
<style lang="css" scoped>
.nome {
  font-family: Roboto, sans-serif;
  font-size: 15px;
}
</style>
